module.exports = __webpack_public_path__ + "FixelDisplay-ExtraLight-2b538c6029a3d152fd642e1eea9e520a.woff2";